export type ShareTypes = 'facebook' | 'pinterest' | 'twitter' | 'email';

export const SHARE_TYPES = {
  facebook: 'facebook' as ShareTypes,
  pinterest: 'pinterest' as ShareTypes,
  twitter: 'twitter' as ShareTypes,
  email: 'email' as ShareTypes,
};

export interface ShareInterface {
  share(): void;
}
